import React from "react";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { LiaWindowClose } from "react-icons/lia";

const InnerCasinControl = ({
  title,
  data,
  show,
  setShow,
  index,
  selected,
  updateCasinoStatus,
}) => {
  return (
    <div className="casino-control-bottom-outer">
      <div className="casino-control-bottom">
        {show ? (
          <FaMinusSquare
            onClick={() => setShow(index)}
            style={{ marginRight: "10px" }}
            size={18}
          />
        ) : (
          <FaPlusSquare
            onClick={() => setShow(index)}
            style={{ marginRight: "10px" }}
            size={18}
          />
        )}
        <span>{title}</span>
      </div>
      {show && (
        <div className="casino-control-bottom-detail">
          {data?.map((res) => {
            let checked = res?.status == "on";
            return (
              <div key={res?.gameCode}>
                <LiaWindowClose size={20} />
                <span>{res?.name}</span>
                <input
                  key={res?.gameCode}
                  name={res?.gameCode}
                  checked={checked}
                  onClick={(e) =>
                    updateCasinoStatus({
                      title: title,
                      status: checked ? "off" : "on",
                      gameCode:res?.gameCode
                    })
                  }
                  type="radio"
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default InnerCasinControl;
